import { render, staticRenderFns } from "./registerEntry_tl12.vue?vue&type=template&id=4afc1f22&scoped=true"
import script from "./registerEntry_tl12.vue?vue&type=script&lang=js"
export * from "./registerEntry_tl12.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/registerEntry_tl12.scss?vue&type=style&index=0&id=4afc1f22&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc1f22",
  null
  
)

export default component.exports